type Props = {
    categories: string[];
    activeCategory: string | null;
    onChange: (category: string) => void;
    renderMobileContent: (category: string) => React.ReactNode;
};

export default function UsedProductContitionsCategoryTabs({
    categories,
    activeCategory,
    onChange,
    renderMobileContent,
}: Props) {
    return (
        <ul>
            {categories.map((category) => {
                const isActive = activeCategory === category;

                return (
                    <li key={category} className="border mb-2">
                        {/* TAB HEADER */}
                        <div
                            className={`cursor-pointer py-2 px-4 uppercase text-sm ${
                                isActive ? "font-bold bg-gray-100" : ""
                            }`}
                            onClick={() => {
                                if (!isActive) onChange(category);
                            }}
                        >
                            {category}
                        </div>

                        {/* MOBILE ACCORDION CONTENT */}
                        <div
                            className={`
                                lg:hidden
                                overflow-hidden
                                transition-all
                                duration-300
                                ease-in-out
                                ${
                                isActive
                                    ? "max-h-[2000px] opacity-100"
                                    : "max-h-0 opacity-0"
                                }
                            `}
                        >
                            {renderMobileContent(category)}
                        </div>
                    </li>
                );
            })}
        </ul>
    );
}
